import React from 'react'
import { connect } from 'react-redux'
import { deleteSubscription, toggleActiveSubscription } from '../actions/subscriptions'

function mapStateToProps(state, props) {
    const { services } = state.services.entities
    const { entities, result, isFetching, filters } = state.subscriptions
    const { providers } = state.providers.entities

    const filter = filters[props.filterId]
    const searchKey = filter && filter.searchKey

    // Extract providerId from filterId (format: 'p_123')
    const providerId =
        props.filterId && props.filterId.startsWith('p_')
            ? parseInt(props.filterId.substring(2))
            : null

    const provider = providerId && providers ? providers[providerId] : null

    return {
        entities,
        services,
        pages: result[searchKey] || {},
        filter,
        isFetching,
        provider,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleActiveSubscription: (subId) => dispatch(toggleActiveSubscription(subId)),
        deleteSubscription: (subId) => dispatch(deleteSubscription(subId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
